import { ServiceError } from '@/types/service';

// TODO: should have name space for each hook, eg: ITEM_ABC, ORDER_ABC,...
export enum QueryKeys {
  ITEM = 'Item',
  CLIENT_ID = 'ClientId',
  CLIENT_EMAIL = 'ClientEmail',
  CLIENT_PHONE_NUMBER = 'ClientPhoneNumber',
  ORDER = 'Order',
  TALONONE_PROMO_RESPONSE = 'TalononePromoResponse',
  TALONONE_CAMPAIGNS = 'TalononeCampaigns',
  HISTO = 'Histo',
  OMS_RETURN_STATUS = 'OmsReturnStatus',
  ITEM_ATTRIBUTES = 'ItemAttributes',
  ITEM_SECTIONS = 'ItemSections',
  ITEM_BRANDS = 'ItemBrands',
  ITEM_MODELS = 'ItemModels',
  ITEM_RETURN_REASONS = 'ItemReturnReasons',
  ITEM_RELIST_PRICE = 'ItemRelistPrice',
  ITEM_CURRENCIES = 'ItemCurrencies',
  CLIENT_ACTION_HISTOS = 'ClientActionHistos',
  PERSONA_KYC_HISTOS = 'PersonaKycHistos',
  CLIENT_BADGES = 'ClientBadges',
  CLIENT_SALES_REPORTS = 'ClientSalesReports',
  ORDER_REFUND_DETAIL = 'OrderRefundDetail',
  ORDER_EXTRA_REFUND_DETAIL = 'OrderExtraRefundDetail',
  ITEM_MMAO = 'ItemMmao',
  ITEM_PHOTOS = 'ItemPhotos',
  ITEM_CURATION_STATUS = 'ItemCurationStatus',
  SIFT_SCORE = 'SiftScore',
  LAST_LOGIN_ATTEMPT = 'LastLoginAttempt',
  CLIENT_CHAT_MODERATE_STATS = 'ClientChatModerateStats',
  ORDER_INVOICE = 'OrderInvoice',
  ITEM_CREATE_RETURN_LITIGATION = 'ItemCreateReturnLitigation',
  ITEM_REPLACE_RETURN_LITIGATION = 'ItemReplaceReturnLitigation',
  ITEM_RETURN_FORM_LINK = 'ItemReturnFormLink',
  ITEM_REQUIRE_AUTHENTICATION = 'ItemRequireAuthentication',
  ITEM_ACTION_LOG = 'ItemActionLog',
  UPLOAD_DOCUMENT_PERMISSION = 'UploadDocumentPermission',
  GET_DOCUMENT = 'GetDocument',
  CANCEL_REASONS = 'CancelReasons',
  CANCELED_SALES = 'ClientCanceledSales',
  CARRIERS = 'Carriers',
  DSA_REPORTS = 'DsaReports',
  POSTAL_LITIGATION = 'PostalLitigation',
  GET_CHARGE_BACK = 'GetChargeBack',
  SHIPPING_FROM_ADDRESS = 'ShippingFromAddress',
  POSTAL_LITIGATION_DECISIONS = 'PostalLitigationDecisions',
  CLIENT_STATS = 'ClientStats',
  PAY_BY_LINK_DETAIL = 'payByLinkDetail',
  PAY_BY_LINK_FORM = 'PAY_BY_LINK_FORM',
  PAYOUT_STATUS_DETAIL = 'PayoutStatusDetail',
  COMPLIANCE_INVOICE_REQUEST = 'ComplianceInvoiceRequest',
  GET_SHIPPING_REMINDER = 'GetShippingReminder',
  GET_PURCHASE_PLACES = 'GetPurchasePlaces',
  GET_AUTHENTICATION_ASK_INFO = 'GetAuthenticationAskInfo',
  SUBMIT_AUTHENTICATION_ASK_INFO = 'MutateAuthenticationAskInfo',
  GET_SELLER_SHIPPING_STATUS = 'GetSellerShippingStatus',
  RESTART_WORKFLOW = 'RestartWorkflow',
  CLIENT_RELIABILITY_STATS = 'ClientReliabilityStats',
}

type RQFn = {
  refetch: () => void;
  remove: () => void;
};

export type RQQuery<D> =
  | ({ kind: 'Called'; fetching: boolean } & RQFn) // Called RQ but may not fetching because of RQ enabled = false - If you are not using enabled, then Called is first fetching = true
  | ({ kind: 'Error'; error: ServiceError } & RQFn) // Service ko
  | ({ kind: 'Loaded'; data: D; refetching: boolean } & RQFn); // Service ok with refetching status

export type RQMutation<P, D> =
  | { kind: 'Called'; mutate: (p: P) => void }
  | { kind: 'Loading'; mutate: (p: P) => void }
  | { kind: 'Error'; error: ServiceError; mutate: (p: P) => void }
  | { kind: 'Completed'; data: D; mutate: (p: P) => void };
